import {
  Component, ChangeDetectionStrategy,
} from '@angular/core'

@Component({
  selector: 'kb-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class LabelComponent {

}
